/**
 * @fileoverview GET handler for the "/alloys/integrations/:integration_id/bridge" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysIntegrationsIntegrationIdBridge } from "./constants";
import type { AlloysIntegrationsIntegrationIdBridgeResult } from "./types";

export const getAlloysIntegrationsIntegrationIdBridge = reactQueryFetcherAdapter(
  alloysIntegrationsIntegrationIdBridge,
  (signal: AbortSignal, integrationId: string): Promise<AlloysIntegrationsIntegrationIdBridgeResult> => {
    return fetch(`/alloys/integrations/${integrationId}/bridge`, "GET", {}, { signal });
  }
);
